import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import "./assets/css/reset.scss";
import "@/mock";
import "amfe-flexible";
import "@/assets/font/font.css";
import { downloadGame } from "@/util/downloadGame.js";
import { messageListener, readyNotify } from "./util/h5sdkevent.js";

Vue.prototype.$downloadGame = downloadGame;

Vue.config.productionTip = false;
Vue.use(Vant);

// messageListener();
// readyNotify();


import VConsole from "vconsole";

new Vue({
  created() {
    if ((location.href || "").indexOf("yoiyiConsole=true") > -1) {
      new VConsole();
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');

